import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { Subject } from 'rxjs';
import { MainPageService } from '../../../main-page.service';

@Component({
  selector: 'app-pipering-family-managment',
  template: `<div *ngIf="piperingFamilyData !== undefined && piperingFamilyData !== null">
    <div class="row" style="padding-left: 12px;">
        <b>Pipe ring family:</b> &nbsp;{{piperingFamilyData.name}}</div>
    <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
    <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid || ctrl2.invalid" (click)="save()">Save</button>
    <div class="row">

        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-3">Name:
                </div>
                <input type="text" class="col-4" [(ngModel)]="piperingFamilyData.name" #ctrl="ngModel" required>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Description:
                </div>
                <input type="text" class="col-4" [(ngModel)]="piperingFamilyData.description">
            </div>
            <div class="display-flex">
                <div class="col-3">Graphical representatation:
                </div>
                <select name="" id="" [(ngModel)]="piperingFamilyData.graphicalRepresentation" #ctrl2="ngModel" required>
                    <option *ngFor="let graphicalRepresentation of graphicalRepresentationsArray | sortByName" [(value)]="graphicalRepresentation.code">{{graphicalRepresentation.value}}</option>
                </select>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class PiperingFamilyManagmentComponent implements OnInit {
  public piperingFamilyData: any;
  public isPiperingFamilyNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public graphicalRepresentationsArray: string[]= [];

  constructor(private mainPageService: MainPageService, private zone: NgZone) { }

  public ngOnInit(): void {
  }

  loadData(): void {
    this.graphicalRepresentationsArray = this.mainPageService.getPipeRingGraphicalRepresentationsArray();
  }

  public showManagmentPage(sender, isNew?) {
    this.piperingFamilyData = sender;
    this.isPiperingFamilyNew = isNew;
    this.loadData();
  }

  save(): void {
    this.mainPageService.updatePiperingFamilyInDb(JSON.stringify(this.piperingFamilyData)).subscribe((res) => { });
    if (this.isPiperingFamilyNew) {
      this.isPiperingFamilyNew = false;
    }
  }

  returnHandler() {
    if (this.isPiperingFamilyNew) {
      this.mainPageService.removePiperingFamily(this.piperingFamilyData._id).subscribe(() => { });
      this.mainPageService.deletePiperingFamilySubject.next(this.piperingFamilyData._id);
      this.piperingFamilyData = null;
    }
    this.stateSubject.next(this.piperingFamilyData);
    this.piperingFamilyData = null;
  }
}
